// RSVP word lists for the HeroRSVP speed-reader.
export const STORIES = {
  tla: {
    title: "What Is TLA",
    words: [
      "TLA","stands","for","Three","Letter","Acronym,","which","is","itself","a","TLA.",
      "But","wait—","if","you","abbreviate","Three","Letter","Acronym,",
      "you","get","TLA.","So","TLA","is","a","TLA","for","TLA.",
      "This","is","called","a","recursive","acronym.","Much","like","GNU,",
      "which","stands","for","GNU's","Not","Unix.",
      "Your","brain","may","now","need","a","reboot.",
      "That's","an","NBR:","Needed","Brain","Reboot—",
      "another","TLA,","obviously.",
    ],
  },
  buzzword: {
    title: "The Buzzword Ballet",
    words: [
      "Welcome","to","the","Buzzword","Ballet.",
      "Every","agency","has","one.","A","manifesto","dripping","with","jargon.",
      "We","leverage","synergies","to","disrupt","the","paradigm.",
      "We","circle","back","to","align","on","key","deliverables,",
      "while","moving","the","needle","on","holistic","growth","hacking.",
      "Let's","ideate","a","scalable","pipeline","of","thought","leadership",
      "and","double","click","on","our","north","star","metrics.",
      "We","have","a","360°","view","of","the","customer","journey.",
      "Our","AI-powered","blockchain","metaverse","is","Web3-native.",
      "We","pivot","at","scale.","We","fail","fast.","We","fail","forward.",
      "We","put","the","human","back","in","human-centred","design.",
      "We","are","thought","leaders","in","the","space.",
      "We","are","all","about","the","culture.",
      "There","is","no","I","in","synergy,",
      "but","there","is","a","Y—",
      "as","in,","why","are","we","still","talking?",
      "We","built","TLA","instead.",
      "No","ballet.","Just","the","work.",
    ],
  },
  origin: {
    title: "The Origin",
    words: [
      "We","are","athletes.","Engineers.","Physicists.","Authors.","Designers.",
      "We","didn't","start","an","agency.","We","started","solving","problems.",
      "Football","taught","us","performance.","Code","taught","us","precision.",
      "Data","taught","us","truth.",
      "We","saved","20%","on","SaaS","bills.",
      "And","built","a","company","around","never","accepting","bad","deals.",
      "Now","we","build","for","children's","books.",
      "For","anyone","bold","enough","to","demand","better.",
      "Creative.","Technology.","Strategy.","Capital.","Mentorship.",
      "We","give","it","back","to","the","people","who","build","it.",
      "Welcome","to","TLA","Studios.",
      "Challenge","us","to","a","match.",
    ],
  },
  acronyms: {
    title: "TLA Could Mean...",
    words: [
      "Totally","Legitimate","Approach.",
      "Tactical","Llama","Acquisition.",
      "Three","Lads","Arguing.",
      "Tremendously","Late","Again.",
      "Tacos,","Lasagne,","Avocados.",
      "Technically","Legal","Activities.",
      "Truly","Loud","Athletes.",
      "The","Last","Agency.",
      "Too","Long;","Abbreviated.",
      "Tenacious","League","of","Audacity.",
      "—","En","español:","—",
      "Tres","Letras","Absurdas.",
      "Tenemos","Logros","Atléticos.",
      "Todo","Lo","Arreglamos.",
      "Trabajo,","Lealtad,","Aventura.",
      "Tácticas","Ligeramente","Atrevidas.",
      "Totalmente","Locos","y","Ambiciosos.",
      "—","In","both","languages:","—",
      "TLA","means","whatever","you","need","it","to.",
      "That's","the","point.",
    ],
  },
};
